import { getLabel } from "@apps/use-label/use-label";
import { pluralize } from "@helpers/string";

export const recognitionRecipientListString = (artifact: any, max = 3) => {
  if (artifact.recipients.totalCount === 1)
    return artifact.recipients.edges[0]?.node.name;
  if (artifact.recipients.totalCount > 1) {
    const userNames = artifact.recipients.edges
      .slice(0, max)
      .map(({ node }: { node: any }) => node.name);
    const remaining = artifact.recipients.totalCount - userNames.length;
    const listNames =
      remaining > 0
        ? userNames.concat(`${remaining} ${pluralize("person", remaining)}`)
        : userNames;
    const lf = new Intl.ListFormat("en");
    return lf.format(listNames);
  }
  return `${artifact.recipients.totalCount} ${pluralize(
    "person",
    artifact.recipients.totalCount,
  )}`;
};

export const getRecognitionRecipientTitle = (artifact: any) => {
  const label = getLabel();
  return `${recognitionRecipientListString(artifact)} received a ${label(
    "recognition",
  )}${
    artifact.recognitionCoreValue
      ? ` for ${artifact.recognitionCoreValue.title}`
      : ""
  } from ${artifact.creator.name}`;
};
